<template>
  <article class="smart-hotel-card" @click="$emit('toHotelDetail', hotel)">
    <div class="hotel-summary">
      <el-image class="hotel-image" :src="hotel.imageUrl || ''" fit="cover" :alt="hotel.name">
        <img slot="error" class="hotel-image-fallback" src="@/assets/newImage/noSwiperImg.png" alt="暂无酒店图片"/>
      </el-image>
      <div class="hotel-info">
        <header><h3 :title="hotel.name">{{ hotel.name }}</h3></header>
        <p class="location" v-if="hotel.distanceInMeters">
          <span>距{{ hotel.location }} {{(hotel.distanceInMeters / 1000).toFixed(2) }}km</span>
        </p>
        <div class="tags">
          <span v-for="tag in hotel.tagNames" :key="tag">{{ tag }}</span>
        </div>
        <div class="reference-price">
          <strong v-if="hotel.roomRatePlans.length">¥{{ hotel.lowestPrice ? hotel.lowestPrice : 0 }}</strong>
          <strong v-else style="color: #8791a5;font-size: 15px">已售罄</strong>
          <span v-if="hotel.roomRatePlans.length">/晚起 · 参考价</span>
        </div>
      </div>
    </div>
    <div class="rooms-title">
      <div class="rooms-label">可售房型 · 实时价<span class="room-count">共 {{ hotel.roomRatePlans.length }} 个报价</span></div>
      <div v-if="staySummary.details" class="stay-summary">
        <strong v-if="staySummary.dates">{{ staySummary.dates }}</strong>
        <span>{{ staySummary.details }}</span>
      </div>
    </div>
    <div class="room-list" :tabindex="hotel.roomRatePlans.length > 2 ? 0 : null" aria-label="房型报价列表，可滚动查看更多报价">
      <div v-for="(room, index) in hotel.roomRatePlans" :key="index" class="room-row">
        <div class="room-info"><h4 :title="room.roomNameCn">{{ room.roomNameCn }}</h4>
          <p :title="room.policy">{{ room.policy }}</p></div>
        <div class="room-price"><strong>¥{{ room.totalPrice }}</strong><span>含税总价</span></div>
        <button type="button" @click.stop="$emit('book', { hotel: hotel, room: room })">去预订</button>
      </div>
    </div>
  </article>
</template>

<script>
function parseStayDate (value) {
  const match = typeof value === 'string' && /^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/.exec(value)
  if (!match) return null
  const time = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
  if (new Date(time).toISOString().slice(0, 10) !== match[0].slice(0, 10)) return null
  return { time, label: match[2] + '.' + match[3] }
}

export default {
  props: {
    hotel: {type: Object, required: true},
    landmark: {type: String, default: ''}
  },
  computed: {
    staySummary () {
      const checkIn = parseStayDate(this.hotel.checkInDate)
      const checkOut = parseStayDate(this.hotel.checkOutDate)
      const details = []
      let dates = ''
      if (checkIn && checkOut && checkOut.time > checkIn.time) {
        dates = checkIn.label + '-' + checkOut.label
        details.push((checkOut.time - checkIn.time) / 86400000 + '晚')
      }
      if (this.hotel.roomCount > 0) details.push(this.hotel.roomCount + '间')
      if (this.hotel.adultCount > 0) details.push(this.hotel.adultCount + '成人')
      return { dates, details: details.join(' · ') }
    }
  }
}
</script>

<style scoped>
.smart-hotel-card {
  padding: 16px;
  min-width: 0;
  min-height: 304px;
  background: #fff;
  border: 1px solid #dce5f5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(36, 55, 92, .03);
  box-sizing: border-box;
}

.smart-hotel-card, .smart-hotel-card :not(i) {
  font-family: '苹方', 'PingFang SC', sans-serif !important;
}

header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  justify-content: space-between;
}

.hotel-summary {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.hotel-image {
  display: block;
  width: 112px;
  height: 108px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #f1f4f9;
}

.hotel-image-fallback {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hotel-info {
  flex: 1;
  min-width: 0;
  min-height: 108px;
}

h3 {
  font-size: 14px;
  line-height: 21px;
  font-weight: 600;
  color: #252e3f;
  margin: 0;
  overflow-wrap: break-word;
}

.match-badge {
  flex-shrink: 0;
  color: #008e68;
  background: #e9f7f2;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 10px;
  line-height: 14px;
}

.location {
  margin: 6px 0 0;
  min-height: 16px;
  font-size: 11px;
  line-height: 16px;
  color: #738098;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  min-height: 21px;
  margin-top: 8px;
  align-content: flex-start;
  gap: 5px;
}

.tags span {
  border: 1px solid #e0e5ef;
  border-radius: 3px;
  color: #61708b;
  padding: 2px 5px;
  font-size: 10px;
  line-height: 15px;
}

.reference-price {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin: 12px 0 0;
  flex-wrap: wrap;
}

.reference-price strong {
  color: #fa572e;
  font-size: 24px;
  line-height: 28px;
  font-weight: 700;
}

.reference-price span {
  color: #999;
  font-size: 10px;
}

.rooms-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px 8px;
  border-top: 1px dashed #dce3f0;
  padding-top: 12px;
  margin-bottom: 7px;
  font-size: 11px;
  font-weight: 600;
  color: #687690;
}

.rooms-label {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.room-count {
  margin-left: 6px;
  padding-left: 6px;
  border-left: 1px solid #dce3f0;
  font-size: 10px;
  font-weight: normal;
  color: #8993a5;
}

.stay-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-left: auto;
  padding: 3px 8px;
  border: 1px solid #e0e7f4;
  border-radius: 12px;
  background: #f6f8fc;
  color: #738098;
  font-size: 10px;
  line-height: 14px;
  font-weight: normal;
}

.stay-summary strong {
  color: #38445a;
  font-weight: 600;
}

.room-list {
  height: 107px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: #c5cfe2 transparent;
}

.room-list::-webkit-scrollbar {
  width: 5px;
}

.room-list::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

.room-list::-webkit-scrollbar-thumb {
  background: #c5cfe2;
  border-radius: 5px;
}

/* Chromium's standard scrollbar properties override its custom scrollbar pseudo-elements. */
@supports (-webkit-appearance: none) {
  .room-list {
    scrollbar-width: auto;
    scrollbar-color: auto;
  }

  .room-list::-webkit-scrollbar-button:vertical:decrement,
  .room-list::-webkit-scrollbar-button:vertical:increment {
    display: none;
    width: 0;
    height: 0;
  }
}

.room-list:focus-visible {
  outline: 2px solid #2454ff;
  outline-offset: 2px;
}

.room-row {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f6f8fc;
  border-radius: 6px;
  padding: 8px 10px;
  height: 50px;
  box-sizing: border-box;
}

.room-row + .room-row {
  margin-top: 7px;
}

.room-info {
  flex: 1;
  min-width: 0;
}

h4 {
  color: #38445a;
  font-size: 12px;
  line-height: 17px;
  margin: 0;
  font-weight: 600;
}

.room-info h4, .room-info p {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.room-info p {
  color: #738098;
  font-size: 10px;
  line-height: 15px;
  margin: 1px 0 0;
}

.room-price {
  display: flex;
  flex-direction: column;
  text-align: right;
  flex-shrink: 0;
}

.room-price strong {
  color: #fa572e;
  font-size: 18px;
  line-height: 21px;
  font-weight: 700;
}

.room-price span {
  color: #89919f;
  font-size: 9px;
  line-height: 13px;
}

.room-row button {
  border: 0;
  color: #fff;
  background: #2553fa;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 3px 8px rgba(37, 83, 250, .15);
}

.room-row button:hover {
  background: #1645e5;
}

.room-row button:focus-visible {
  outline: 2px solid #2454ff;
  outline-offset: 3px;
}

@media (max-width: 400px) {
  .hotel-image {
    width: 88px;
    height: 108px;
  }

  .hotel-summary {
    gap: 10px;
  }

  .smart-hotel-card {
    padding: 12px;
  }

  .room-row {
    gap: 7px;
    padding: 8px;
  }

  button {
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/smartHotelSearch/HotelCard.vue